module.exports = __webpack_public_path__ + "static/img/m_banner1.4b2a85b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/m_banner1.png
// module id = 7Dk2
// module chunks = 0